import { AI_TOOL_SELECT_USAGE_NOTE } from '@erikdakoda/ai-tool/findManyAiToolInput';
import { tool, zodSchema } from 'ai';
import { z } from 'zod';
import type { AiTool } from '@erikdakoda/ai-tool/types';
import { botsToolGroupIcon } from './toolGroupIcon';
import { searchBotsInputSchema } from './botAiToolInputSchemas';

export { searchBotsInputSchema };

export const searchBotsOutputSchema = z.object({
  results: z
    .array(z.unknown())
    .describe(
      'Matching bots. Default minimal mask: id, name, description, group, handle. Shape follows expanded flat `select` when provided.',
    ),
  count: z.number().int().describe('Number of rows returned (after limit)'),
});

export type SearchBotsInput = z.infer<typeof searchBotsInputSchema>;
export type SearchBotsOutput = z.infer<typeof searchBotsOutputSchema>;

export const searchBots: AiTool<undefined, SearchBotsInput, SearchBotsOutput> = {
  id: 'searchBots',

  group: 'bots',

  ...botsToolGroupIcon,

  userSelect: false,

  access: 'READ',

  tool: tool({
    description: `Deprecated: prefer findBots with searchText. Search bots by name (substring) and description (full-text / english stem). Does not search group or handle.

Returns id, name, description, group, and handle by default. ${AI_TOOL_SELECT_USAGE_NOTE}

By default **published and draft** bots are returned. Pass \`onlyPublished: true\` to restrict to published bots only.`,
    inputSchema: zodSchema(searchBotsInputSchema),
    outputSchema: zodSchema(searchBotsOutputSchema),
  }),
};
